import { TimelineState, TimilineAction } from "./types";
import {API_AUTH_RESET} from "../../constants/API";

const initialState = {
    time: Date.now(),
    startTime: 0,
    endTime: 0,
    duration: 0,
    scaleMarkInterval: 0,
    scaleTimeMarkInterval: 0,
    browsePanes: {},
    timelineScale: typeof (window.CONFIG) !== 'undefined' ? window.CONFIG.timelinePreset : 1,
    reloadTimestrips: 0,
    title: '30 min',
    speedPlayback: (typeof (window.CONFIG) !== 'undefined' && typeof (window.CONFIG.playbackSpeed) !== 'undefined') ? window.CONFIG.playbackSpeed.middle : 1,
    playbackMode: 'pause',
    changeIconView: true,
    draggableCamId: null
};

const reducer = (state: TimelineState = initialState, action: TimilineAction) => {
    switch(action.type) {
        case('setTimelineDate'): return {
            ...state,
            time: action.time,
            playbackMode: action.playbackMode ? action.playbackMode : state.playbackMode
        };

        case('resetTimestrips'): return {
            ...state,
            time: +action.time,
            browsePanes: {
                ...state.browsePanes,
                [0]: {
                    ...state.browsePanes[0],
                    data: null
                },
                [1]: {
                    ...state.browsePanes[1],
                    data: null
                }
            }
        };

        case('setZoomRulerValues'): return {
            ...state,
            duration: action.duration,
            scaleMarkInterval: action.scaleMarkInterval,
            scaleTimeMarkInterval: action.scaleTimeMarkInterval,
            title: action.title
        };

        case('setZoomTimelineScale'): return {
            ...state,
            timelineScale: action.timelineScale
        };


        case('setCurrentLayout'): return {
            ...state,
            browsePanes: {}
        };

        case('setSpeedPlayback'): return {
            ...state,
            speedPlayback: action.speed
        };

        case('setPlaybackMode'): return {
            ...state,
            playbackMode: action.playbackMode,
            changeIconView: action.changeIconView
        };

        case('setBookmarkCheckedPane'): return {
            ...state,
            time: action.time
        };

        case('@@router/LOCATION_CHANGE'): return {
            ...state,
            playbackMode: 'pause'
        };

        case API_AUTH_RESET : return {
            ...initialState
        };

        default: return state
    }
};

export default reducer